const whitelist = [
  'popup/meeting.php',
  'popup/callback.php',
  'popup/external_costs_project.php',
  'popup/external_costs_project_bestelbon.php',
  'popup/sales_phase.php',
  'popup/project.php',
  'popup/milestone.php',
  'popup/deal.php',
  'popup/pricing_timetracking.php',
  'popup/todo.php',
  'popup/ticket.php',
  'popup/meeting_done',
  'popup/meeting_report_description.php',
  'popup/presale_offerte.php',
  'popup/invoice_reminder.php',
  'popup/create_invoice_from_deal.php',
  'popup/inv_invoices.php',
  'popup/inv_invoice_edit_address.php',
  'popup/invoice_setpaid.php',
  'popup/sale_send_offer.php',
  'popup/timetracking.php',
  'popup/selectQuotation.php',
  'popup/project_template.php',
  'popup/link_offer.php',
  'popup/admin_account_deal_link.php',
  'popup/admin_change_preference_extra_info.php',
  'popup/admin_document_renumbering.php',
  'popup/groups_linked_company.php',
  'popup/groups_reseller_link.php',
  'popup/mark_as_channel_partner.php',
  'popup/groups_teamleader_wallet.php',
  'popup/deactivate_account.php',
  'popup/groups_clients.php',
  'popup/sys_group.php',
  'popup/advanced_timetracking.php',
  'popup/agendaDragHandler.php',
  'popup/appointment_workorder_suggestion.php',
  'popup/attachments.php',
  'popup/vat_rate_account_links.php',
  'popup/bookkeeping_export.php',
  'popup/bookkeeping_export_customer_ids.php',
  'popup/bulk_export.php',
  'popup/invoice_export.php',
  'popup/xls_export.php',
  'popup/xls_template.php',
  'popup/callback_info.php',
  '/app/calls/',
  '/app/admin/accounts',
  'popup/call_outcome.php',
  'popup/call_recording.php',
  'popup/callback_done.php',
  'popup/callback_tlvoice.php',
  'popup/product.php',
  'popup/inv_creditnote.php',
  'popup/inv_projects.php',
  'popup/inv_subscriptions.php',
  'popup/agendaDragHandler.php',
  'popup/inv_invoice_permanent.php',
  'popup/presale_offerte.php',
  'popup/ticket_extra_parties.php',
  'popup/employee_foto.php',
  'popup/company_foto.php',
  'popup/contact_foto.php',
  'popup/product_foto.php',
  'popup/email.php',
  'popup/plan_existing_todo.php',
  'popup/do_action.php',
  'popup/order_send.php',
  'popup/vacation_type.php',
  'popup/customer_invoice_preferences.php',
  'popup/pricing_timetracking_update.php',
  'popup/tracking.php',
  'popup/discover_quotation_articles.php',
  'popup/tag.php',
  'popup/team.php',
  'popup/template_custom_css.php',
  'popup/text_template.php',
  'popup/text_template.php',
  'popup/ticket_autoclosing_switch.php',
  'popup/ticket_autoreply.php',
  'popup/ticket_custom_status.php',
  'popup/ticket_setup.php',
  'popup/segment.php',
  'popup/segment_documents.php',
  'popup/self_autograph.php',
  'popup/admin_file_modifier.php',
  'popup/clickToDial.php',
  'popup/client_project_link.php',
  'popup/cm-retrieve-access-tokens.php',
  'popup/columns.php',
  'popup/custom_field.php',
  'popup/settings_custom_options_editor.php',
  'popup/custom_routing.php',
  'popup/custom_target.php',
  'popup/hr_report_switch.php',
  'popup/import.php',
  'popup/incasso.php',
  'popup/inv_alternative_bank_account.php',
  'popup/inv_automatic_reminders.php',
  'popup/inv_background_info.php',
  'popup/inv_bookyear.php',
  'popup/inv_creditnote_edit_date.php',
  'popup/inv_extra_vat_rate.php',
  'popup/inv_invoice_convertcurrency.php',
  'popup/inv_invoice_edit_date.php',
  'popup/inv_invoice_edit_layout.php',
  'popup/inv_invoice_edit_po_number.php',
  'popup/customfield_textblob.php',
  'popup/deactivate_employee.php',
  'popup/default_invoice_pricing_type.php',
  'popup/download_invoice.php',
  'popup/description.php',
  'popup/employee_days_off_export.php',
  'popup/employee_show_stats.php',
  'popup/employees_show_stats.php',
  'popup/employee_targets.php',
  'popup/employee_week_schedule.php',
  'popup/bookkeeping_account.php',
  'popup/word_template_vars.php',
  'popup/werkbonnen_notifications.php',
  'popup/employee.php',
  'popup/webhook.php',
  'popup/validation.php',
  'popup/trendstop_lookup.php',
  'popup/transfer_employee_data.php',
  'popup/corc_merge.php',
  'popup/corc_merge_conflicting_fields.php',
  'popup/cost_per_km.php',
  'popup/edit_email_template.php',
  'popup/email_template.php',
  'popup/report_project.php',
  'popup/report_ticket.php',
  'popup/remove_recurring_object.php',
  'popup/recurring_meeting_remove_all.php',
  'popup/project_delete.php',
  'popup/project_export.php',
  'popup/project_relation_link.php',
  'popup/project_automatic_invoicing.php',
  'popup/project_client_external_access.php',
  'popup/project_thirdparty_external_access.php',
  'popup/edit_document_item.php',
  'popup/edit_document_item_mc.php',
  'popup/edit_template.php',
  'popup/new_template.php',
  'popup/file_from_template.php',
  'popup/event.php',
  'popup/event_participant_link.php',
  'popup/event_session_link.php',
  'popup/product_supplier.php',
  'popup/product_export.php',
  'popup/products_report.php',
  'popup/inv_timetracking.php',
  'popup/inv_timetracking_report.php',
  'popup/inv_vat_lines_editor.php',
  'popup/invoice_discount.php',
  'popup/invoice_show_stats.php',
  'popup/invoice_targets.php',
  'popup/leveringsbon_from_offer.php',
  'popup/leveringsbon_productie.php',
  'popup/file-download-no-preview.php',
  'popup/file-download-no-access.php',
  'popup/create_extra_shortcode.php',
  'popup/upload_file.php',
  'popup/link_to_project.php',
  'popup/limit_timetracking_switch.php',
  'popup/meeting_copy.php',
  'popup/meeting_item.php',
  'popup/meeting_start_location.php',
  'popup/merge_ticket.php',
  'popup/missedCallUnknown.php',
  'popup/new_layout_template.php',
  'popup/notimetracking.php',
  'popup/order_delivery_status.php',
  'popup/planning_team_dates.php',
  'popup/presale_articles_orderconfirmation.php',
  'popup/presale_template.php',
  'popup/pricelist.php',
  'popup/self.php',
  'popup/settings_customfield_merge_options.php',
  'popup/settings_products_priceunits.php',
  'popup/stats_filter.php',
  'popup/timesheets_export.php',
  'popup/timetracking_edit_hourly_price.php',
  'popup/todo_kind.php',
  'popup/todo_after_subscription_renewal.php',
  'popup/todo_delete.php',
  'popup/tracking_print.php',
  'popup/edit_ticket_conversation.php',
  'popup/sys_group_reseller.php',
  'popup/todo_done.php',
  'popup/meeting_clients.php',
  'popup/repeat.php',
  'popup/tracking_mail.php',
];

const shouldOpenWithoutIframe = (url: string) => Boolean(whitelist.find((entry) => url.startsWith(entry)));

export default shouldOpenWithoutIframe;
